import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HfContactSectionComponent } from '../hf-contact-section/hf-contact-section.component';
import { HealthFirstService } from '../../services/health-first.service';
import { HfCommentsSectionComponent } from '../hf-comments-section/hf-comments-section.component';
import { HEALTHFIRST_HOME_INFO } from '../hf-home/home-info';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { HfPlanDetailsMobComponent } from '../hf-plan-details-mob/hf-plan-details-mob.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-hf-plans-page',
  standalone: true,
  imports: [
    CommonModule,
    HfContactSectionComponent,
    HfCommentsSectionComponent,
    HfPlanDetailsMobComponent
  ],
  templateUrl: './hf-plans-page.component.html',
  styleUrls: ['./hf-plans-page.component.scss']
})
export class HfPlansPageComponent {
  constructor(
    private events: EventsService,
    private hfService: HealthFirstService,
    public util: UtilService,
    private vars: VariablesService,
    private actRoute: ActivatedRoute
  ) {}
  info = HEALTHFIRST_HOME_INFO;
  showImg = false;
  subs = [];
  planAmountData;
  id = null;
  ngOnInit() {
    this.checkHfData();
    this.getParams()
    this.pageViewEvent();
  }

  pageViewEvent() {
    const pageViewPayload = {
      eventName: 'chooseplan_pageview',
      referrer_page: this.util.getReferrer(),
    };
    if (this.hfService.selectedBenefit) {
      pageViewPayload['info_3'] = this.util.stripHtml(this.hfService.selectedBenefit?.info_2)
    }
    this.events.onLoadSystemEvent(pageViewPayload);
    this.events.claverTapPush('Healthfirst PageView', {
      'Event Name': 'chooseplan_pageview',
      'info_3': this.hfService.selectedBenefit?.info_2 ? this.util.stripHtml(this.hfService.selectedBenefit?.info_2): ''
    });
  }

  getParams() {
    this.subs.push(this.actRoute.queryParams.subscribe(val => {
      if (Object.keys(val).length > 0)  {
        const {id} = val;
        this.id = +id;
      }  
    }));
  }

  ngAfterViewInit() {
    this.util.scrollToTop();
  }

  checkHfData() {
    if (this.vars.hfDashboardData && Object.keys(this.vars.hfDashboardData).length > 0) {
      this.setInfoData(this.vars.hfDashboardData);
    } else {
      this.getHealthPlans();
    }
  }

  setInfoData(data) {
    this.info.plansMob = [];
    const { policies, testimonials, why_should_choose, recommended_plan } = data.data.healthfirst;
    this.info.planDetails.plans = policies.details;
    this.info.recommended_plan = recommended_plan;
    this.planAmountData = policies.plans;
    this.info.plans = policies.benefits.filter(item => 'info_1' in item);
    if (this.hfService.selectedBenefit && this.util.isMobile() || this.id) {
      this.showImg = true;
      if (this.id) {
        this.hfService.selectedBenefit = this.info.plans[this.id - 1];
      }
      this.info.planDetails.header.title2 = this.hfService.selectedBenefit.info_2;
      this.info.planDetails.header['img'] = this.hfService.selectedBenefit.info_1;
    }
    for (const key in policies.plans) {
      if (Object.prototype.hasOwnProperty.call(policies.plans, key)) {
        const element = policies.plans[key];
        this.info.plansMob.push({
          plan: key,
          duration: Object.keys(element)[0],
          amount: element.yearly.amount,
          planId: element.yearly.planId,
          benefits: element.yearly.benefits
        });
      }
    }
    this.info.plans = policies.benefits.filter(item => 'info_1' in item);
    this.info.commentsSection.comments = testimonials;
    this.info.benefits = why_should_choose;
  }

  getHealthPlans() {
    this.hfService.getHealthFirstData().subscribe(data => {
      if (data) {
        this.vars.hfDashboardData = data;
        this.setInfoData(data);
      }
    })
  }

  ngOnDestroy() {
    this.subs.forEach(sub => {
      sub.unsubscribe();
    })
  }
}
